/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Link } from '@gerdau/hefesto';

import {
  Container,
  LinksContainer,
  SkeletonContainer,
  TextBlock,
  CardBlock
} from './styles';

import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { IProductInfo } from '../../../../../services/ProductMvp/types';
import { SortProductsItem } from '../../../../../services/MVP/models';
import { EMeasureUnit } from '../../../../../store/commomTypes';
import ProductCard, {
  ProductImageProps
} from '../../../../../components/Purchase/ProductCard';
import { ProductInfoParagraph, ProductInfoTitle } from '../styles';
import theme from '../../../../../assets/styles/theme/theme';
import { capitalizeWords } from '../../../../../utils/formatStrings';

interface ILink {
  show: boolean;
  navigateTo: () => void;
}

interface IParam {
  product: IProductInfo | undefined;
  title: string;
  content: JSX.Element[] | string | JSX.Element;
  productsLink?: ILink;
  tecnologyLink?: ILink;
  specificationsLink?: ILink;
  detailsLink?: ILink;
}

const ProductDescription = ({
  product,
  content,
  title,
  detailsLink,
  specificationsLink,
  tecnologyLink
}: IParam) => {
  const dispatch = useDispatch();
  const [productCard, setProductCard] = useState<SortProductsItem>();
  const [contentState, setContent] = useState<
    JSX.Element[] | string | JSX.Element
  >('');
  const [titleState, setTitle] = useState<JSX.Element[] | string | JSX.Element>(
    ''
  );
  const [imageCard, setImageCard] = useState<ProductImageProps | undefined>();
  const descricao_gpm = (product: SortProductsItem) => {
    return (
      product.custom_attributes.find(
        (att: { attribute_code: string }) =>
          att.attribute_code === 'descricao_gpm'
      )?.value ?? ''
    );
  };

  useEffect(() => {
    const mapProduct = () => {
      if (product) {
        const card = {
          sku: product.sku,
          name: product.name,
          id: product.id,
          attribute_set_id: product.attribute_set_id,
          created_at: product.created_at,
          updated_at: product.updated_at,
          extension_attributes: product.extension_attributes,
          custom_attributes: product.custom_attributes.map((attribute) => ({
            attribute_code: attribute.attribute_code,
            value: Array.isArray(attribute.value)
              ? attribute.value[0]
              : attribute.value
          })),
          media_gallery_entries: product.media_gallery_entries,
          options: product.options,
          product_links: product.product_links,
          type_id: product.type_id,
          visibility: product.visibility,
          status: product.status,
          tier_prices: product.tier_prices,
          price: {
            creditPrice: product.price.creditPrice,
            destination: product.price.destination,
            destinationDescription: product.price.destinationDescription,
            isAgreementPrice: product.price.isAgreementPrice,
            paymentTerms: product.price.paymentTerms,
            paymentTermsDescription: product.price.paymentTermsDescription,
            um: product.price.um as EMeasureUnit,
            salesAgreementData: {
              agreementUm: product.price.salesAgreementData.agreementUm,
              destination: product.price.salesAgreementData.destination,
              expirationDate: product.price.salesAgreementData.experition_date,
              paymentTerms: product.price.salesAgreementData.paymentTerms,
              paymentTermsDescription:
                product.price.salesAgreementData.paymentTermsDescription,
              salesAgreement: Number(
                product.price.salesAgreementData.salesAgreement
              ),
              destinationDescription:
                product.price.salesAgreementData.destinationDescription,
              um: product.price.um
            }
          },
          salesDate: ''
        } as SortProductsItem;
        const image =
          product.media_gallery_entries &&
          product.media_gallery_entries.length > 0
            ? {
                desktopSource: `${process.env.REACT_APP_MEDIA_BASE_URL}/media/catalog/product/${product.media_gallery_entries[0]?.file}`,
                mobileSource: `${process.env.REACT_APP_MEDIA_BASE_URL}/media/catalog/product/${product.media_gallery_entries[0]?.file}`
              }
            : product?.extension_attributes?.category_links &&
              Array.isArray(product?.extension_attributes?.category_links) &&
              product?.extension_attributes?.category_links.length > 0 &&
              product?.extension_attributes?.category_links[0]?.category_image
            ? {
                desktopSource: `${process.env.REACT_APP_MEDIA_BASE_URL}${
                  product.extension_attributes?.category_links[0]
                    ?.category_image ?? ''
                }`,
                mobileSource: `${process.env.REACT_APP_MEDIA_BASE_URL}${
                  product.extension_attributes?.category_links[0]
                    ?.category_img_mobile ?? ''
                }`
              }
            : undefined;
        setImageCard(image);
        setProductCard(card);

        dispatch(
          sendTagging({
            event: 'view_item',
            ecommerce: {
              currency: 'BRL',
              value: product?.price.creditPrice,
              screenName: 'pagina_de_produto',
              tipo_compra: 'vitrine',
              paginacao: '1',
              items: [
                {
                  screenName: 'vitrine',
                  tipo_compra: 'vitrine',
                  item_id: product?.sku?.toString() ?? '',
                  item_name: product?.name ?? '',
                  price: product?.price.creditPrice,
                  unidade_de_medida: product?.price.um,
                  quantity: '1',
                  item_category: descricao_gpm(
                    product as unknown as SortProductsItem
                  ),
                  cod_gerdau: product?.sku?.toString() ?? '',
                  preco_acordado: product?.price?.isAgreementPrice?.length > 0
                }
              ]
            }
          })
        );
      }
    };
    mapProduct();
  }, [product]);

  useEffect(() => {
    setContent(content);
  }, [content]);

  useEffect(() => {
    setTitle(capitalizeWords(title));
  }, [title]);

  return (
    <>
      <Container>
        {contentState.toString().length > 0 ? (
          <TextBlock>
            <ProductInfoTitle>{titleState}</ProductInfoTitle>
            <ProductInfoParagraph>{contentState}</ProductInfoParagraph>
            <LinksContainer>
              {tecnologyLink?.show && (
                <Link
                  url="Tecnologia"
                  name="Tecnologia"
                  onClick={tecnologyLink.navigateTo}
                />
              )}
              {specificationsLink?.show && (
                <Link
                  url="Especificações técnicas"
                  name="Especificações técnicas"
                  onClick={specificationsLink?.navigateTo}
                />
              )}
              {detailsLink?.show && (
                <Link
                  url="Detalhes técnicos"
                  name="Detalhes técnicos"
                  onClick={detailsLink.navigateTo}
                />
              )}
            </LinksContainer>
          </TextBlock>
        ) : (
          <SkeletonTheme
            color={theme.colors.waterBlue}
            highlightColor={theme.colors.disabledGray}
          >
            <SkeletonContainer>
              <Skeleton width="100%" height="40px" />
              <Skeleton width="100%" height="24px" />
              <Skeleton width="100%" height="24px" />
              <Skeleton width="100%" height="24px" />
              <Skeleton width="80%" height="24px" />
            </SkeletonContainer>
          </SkeletonTheme>
        )}

        {productCard ? (
          <CardBlock>
            <ProductCard
              image={imageCard}
              showLink={false}
              product={productCard}
            />
          </CardBlock>
        ) : (
          <SkeletonTheme
            color={theme.colors.waterBlue}
            highlightColor={theme.colors.disabledGray}
          >
            <SkeletonContainer>
              <Skeleton width="60%" height="40px" />
              <Skeleton width="60%" height="24px" />
              <Skeleton width="60%" height="24px" />
              <Skeleton width="60%" height="24px" />
              <Skeleton width="50%" height="24px" />
            </SkeletonContainer>
          </SkeletonTheme>
        )}
      </Container>
    </>
  );
};

export default ProductDescription;
